import { render, staticRenderFns } from "./ProgramCustomDocVue.vue?vue&type=template&id=8cb1139c&"
import script from "./ProgramCustomDocVue.vue?vue&type=script&lang=js&"
export * from "./ProgramCustomDocVue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports